import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, CheckCircle2 } from 'lucide-react';
import { Button } from './Button';
export function Comparison() {
  return <section className="py-24 px-4 bg-[#F0F2EB]" data-id="element-62">
      <div className="max-w-5xl mx-auto" data-id="element-63">
        <div className="text-center mb-16" data-id="element-64">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-green mb-4" data-id="element-65">
            La diferencia es concreta
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-16" data-id="element-66">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white p-8 rounded-2xl border-t-4 border-terracota shadow-sm" data-id="element-67">
            <h3 className="text-xl font-bold text-terracota mb-6 text-center" data-id="element-68">
              SIN EL MEGA PACK
            </h3>
            <ul className="space-y-4" data-id="element-69">
              {['Información dispersa en múltiples fuentes', 'Clases improvisadas o preparadas de apuro', 'Temas aislados sin conexión visible', 'Actividades que hay que crear desde cero', 'Evaluaciones armadas la noche anterior', 'Proyectos incompletos o sin base técnica', 'Fines de semana planificando'].map((item, i) => <li key={i} className="flex items-start gap-3 text-ink text-sm" data-id="element-70">
                  <XCircle size={18} className="text-terracota/60 shrink-0 mt-0.5" data-id="element-71" />
                  <span data-id="element-72">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-white p-8 rounded-2xl border-t-4 border-green shadow-lg relative" data-id="element-73">
            <div className="absolute -top-3 right-4 bg-gold text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-74">
              TU NUEVA REALIDAD
            </div>
            <h3 className="text-xl font-bold text-green mb-6 text-center" data-id="element-75">
              CON EL MEGA PACK
            </h3>
            <ul className="space-y-4" data-id="element-76">
              {['Contenidos organizados en un sistema lógico', 'Clases estructuradas y listas para dar', 'Proceso completo de la materia prima al mercado', 'paquete de actividades listas para usar', 'Banco de evaluaciones completo por unidad', 'Proyectos productivos reales con formulaciones y costos', 'Fines de semana para vos'].map((item, i) => <li key={i} className="flex items-start gap-3 text-ink text-sm font-medium" data-id="element-77">
                  <CheckCircle2 size={18} className="text-green shrink-0 mt-0.5" data-id="element-78" />
                  <span data-id="element-79">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>

        <div className="bg-white rounded-3xl p-8 md:p-12 border border-gold/30 shadow-sm text-center max-w-3xl mx-auto" data-id="element-80">
          <h3 className="text-2xl font-serif font-bold text-green mb-2" data-id="element-81">
            Un año de Industrialización de Alimentos. Organizado. Listo. Desde
            hoy.
          </h3>

          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 mt-6 mb-8 text-sm text-ink" data-id="element-82">
            <span className="flex items-center gap-1" data-id="element-83">
              <span className="text-green font-bold" data-id="element-84">✓</span> 5 tomos completos
            </span>
            <span className="flex items-center gap-1" data-id="element-85">
              <span className="text-green font-bold" data-id="element-86">✓</span> paquete de
              actividades
            </span>
            <span className="flex items-center gap-1" data-id="element-87">
              <span className="text-green font-bold" data-id="element-88">✓</span> Evaluaciones
            </span>
            <span className="flex items-center gap-1" data-id="element-89">
              <span className="text-green font-bold" data-id="element-90">✓</span> Recetario
            </span>
            <span className="flex items-center gap-1" data-id="element-91">
              <span className="text-green font-bold" data-id="element-92">✓</span> Proyectos
            </span>
          </div>

          <div className="mb-8" data-id="element-93">
            <p className="text-5xl font-bold text-green mb-2" data-id="element-94">USD 19,90</p>
            <p className="text-sm text-terracota font-medium" data-id="element-95">
              Precio promocional disponible por tiempo limitado
            </p>
          </div>

          <Button href="#pricing" variant="terracota" className="mb-4" data-id="element-96">
            QUIERO MI MEGA PACK AHORA
          </Button>

          <div className="flex flex-wrap justify-center gap-4 text-xs text-slate font-medium" data-id="element-97">
            <span data-id="element-98">🔒 Pago seguro</span>
            <span data-id="element-99">⚡ Acceso inmediato</span>
            <span data-id="element-100">💱 Pagás en tu moneda local</span>
            <span data-id="element-101">🛡️ Garantía 7 días</span>
          </div>
        </div>
      </div>
    </section>;
}